import { ReactNode } from 'react';
import { Box, Main } from 'grommet';
import { FooterNav, HeaderNav } from '/src/components';

export const DesktopLayout = ({ children }: { children: ReactNode; showSidebar?: boolean }) => {
  return (
    <Box style={{ minHeight: '100vh' }}>
      <HeaderNav />
      <Main background="light">
        {children}
        <Box>
          <FooterNav />
        </Box>
      </Main>
    </Box>
  );
};
